export default "__VITE_ASSET__DxyGYxmp__"